import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TGetVitrinsOffersResponse } from 'shared/types/TVitrinsService';

/**
 * TODO: Доработать в рамках https://sravni-corp.atlassian.net/browse/CF-3559
 * Any
 */

export const vitrinsQueries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getVitrins: build.query<TGetVitrinsOffersResponse, Record<string, any>>({
      query: (body) => ({
        url: BFF_API_ROUTES.getVitrinsOffers,
        body,
        method: 'POST',
      }),
    }),
  }),
});

export const useGetVitrins = vitrinsQueries.useGetVitrinsQuery;
